import { ALLOWED } from "@/app/infrastructures/misc/RolePermission";

const LoginPage = () =>
  import(/* webpackChunkName: "Login" */ "@/app/ui/views/login/index.vue");
const VerifyOtpPage = () =>
  import(/* webpackChunkName: "Login" */ "@/app/ui/views/login/verify-otp.vue");
const LoginApproval = () =>
  import(/* webpackChunkName: "Login" */ "@/app/ui/views/login/login-approval.vue");
const ResetPassword = () =>
  import(
    /* webpackChunkName: "ResetPassword" */ "@/app/ui/views/reset-password/index.vue"
  );
const ForgotPassword = () =>
  import(
    /* webpackChunkName: "ForgotPassword" */ "@/app/ui/views/forgot-password/index.vue"
  );
const ForgotPasswordExpired = () =>
  import(
    /* webpackChunkName: "ForgotPassword" */ "@/app/ui/views/forgot-password/component/expired.vue"
  );
const SetupPassword = () =>
  import(
    /* webpackChunkName: "SetupPassword" */ "@/app/ui/views/setup-password/index.vue"
  );
const VerificationAccount = () =>
  import(
    /* webpackChunkName: "ResetPassword" */ "@/app/ui/views/force-change-password/index.vue"
  );

const InactiveAccount = () =>
  import(
    /* webpackChunkName: "InactiveAccount" */ "@/app/ui/views/login/inactive-account.vue"
  );

const LoginDeviceLimit = () =>
  import(
    /* webpackChunkName: "LoginDeviceLimit" */ "@/app/ui/views/login/login-device-limit.vue"
  );

export default [
  {
    path: "/",
    name: "login",
    component: LoginPage,
    meta: {
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/login-approval",
    name: "Login Approval",
    component: LoginApproval,
    meta: {
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/inactive-account",
    name: "Inactive Account",
    component: InactiveAccount,
    meta: {
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/login-not-allowed",
    name: "Login Not Allowed",
    component: LoginApproval,
    meta: {
      hidden: true,
      noAuth: true,
      permission: ALLOWED,
      status: "NOT_ALLOWED"
    }
  },
  {
    path: "/account/forgot-password",
    name: "Forgot Password",
    component: ForgotPassword,
    meta: {
      title: "Forgot Password",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/account/forgot-password/expired",
    name: "Verification Expired",
    component: ForgotPasswordExpired,
    meta: {
      title: "Verification Expired",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/account/setup-password",
    name: "Setup Password",
    component: SetupPassword,
    meta: {
      title: "Setup Password",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/account/reset-password",
    name: "Reset Password",
    component: ResetPassword,
    meta: {
      title: "Reset Password",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/account/verification-account",
    name: "Verification Account",
    component: VerificationAccount,
    meta: {
      title: "Verification Account",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/account/verification-otp",
    name: "Verification OTP",
    component: VerificationAccount,
    meta: {
      title: "Verification OTP",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/login-device-limit",
    name: "Login Device Limit",
    component: LoginDeviceLimit,
    meta: {
      title: "Login Device Limit",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
  {
    path: "/login/verify-otp",
    name: "Verify OTP",
    component: VerifyOtpPage,
    meta: {
      title: "Verifikasi OTP",
      hidden: true,
      noAuth: true,
      permission: ALLOWED
    }
  },
];
